import { useEffect } from "react";
import { Typography } from "@mui/material";

import { Loading } from "src/components/utils/Loading";
import { useSettings } from "src/context/Settings/GlobalSettings/useSettings";

export const SettingsInitialRedirection = () => {
    const { tabs, selectedTabIndex } = useSettings();

    useEffect(() => {
        if (selectedTabIndex === undefined) {
            if (tabs.length === 0) {
                return;
            }

            tabs[0].onClick?.();
            return;
        }

        tabs[selectedTabIndex]?.onClick?.();
        // Only effective on mount
    }, []);

    if (tabs.length === 0) {
        return <Typography variant="body-medium">{"Nothing is activated on the platform"}</Typography>;
    }

    return <Loading />;
};
